// @generated by TypeGen from LogbookApi/ManualShipStatusApi - DO NOT EDIT

import type { IManualShipStatusRequest } from "../LogbookApp/ManualShipStatusApi"
import type { IAppResponse } from "../LogbookApp/Routes"
import { IShipUserLevel } from "../LogbookModel/ShipUser"
import { assertTarget } from "./ApiRuntime"
import type { ApiArgs, ApiClient, ApiTarget, ApiUser } from "./ApiRuntime"

export interface ManualShipStatusApiEndpoints {
  "PUT /api/ship/status/manual": {
    params: {};
    query: {};
    request: IManualShipStatusRequest;
    response: IAppResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
}

export const manualShipStatusApiEndpoints = {
  "PUT /api/ship/status/manual": { targets: ["app"], permission: { ship: IShipUserLevel.editCurrent } },
} as const;

export class ManualShipStatusApi {
  constructor(private client: ApiClient) {}

  manualShipStatus = {
    update: (a: ApiArgs<ManualShipStatusApiEndpoints, "PUT /api/ship/status/manual">) => ({
      call: (): Promise<IAppResponse> => {
        assertTarget(this.client, "PUT /api/ship/status/manual", manualShipStatusApiEndpoints["PUT /api/ship/status/manual"].targets);
        return this.client.call<IAppResponse>("PUT /api/ship/status/manual", a);
      },
      url: (): string => this.client.url("PUT /api/ship/status/manual", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel() ?? -1) >= IShipUserLevel.editCurrent,
    }),
  };
}
